<template>
  <app-main-layout class="App-Page-H">
    <!--  -->
    <template v-slot:top-nav>
      <app-top-nav />
    </template>
    <!--  -->
    <template v-slot:main>
      <div>
        <AppWhyE4TTop />
        <div>
          <!-- <app-how-it-works /> -->
        </div>
      </div>
    </template>
    <!--  -->
    <template v-slot:footer>
      <app-main-footer />
    </template>
  </app-main-layout>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import AppWhyE4TTop from "./why-e4t-page-top.vue";
@Options({
  components: { AppWhyE4TTop, },
})
export default class extends Vue {}
</script>

<style lang="scss"></style>
